import React, { Component } from 'react';
import { connect } from 'react-redux';
import EventsListContainer from '../../containers/admin/EventsListContainer';
import EventsDetailContainer from '../../containers/admin/EventsDetailContainer';
import Header from './Header';
import Notification from '../Notification';
import * as styled from '../../styles/style';
import { alertActions } from '../../actions';
import { eventActions } from '../../actions';
import { hostType } from '../../helpers/enums';
import Fuse from 'fuse.js';
import checkRequiredFields, { validString, validRadio, validPostalCode } from '../../helpers/check-required-fields';
import { STEPS, Step } from '../host/Step'

const fuseOptions = {
  shouldSort: true,
  threshold: 0.3,
  location: 0,
  distance: 100,
  maxPatternLength: 32,
  minMatchCharLength: 1,
  keys: [
    "name",
    "email",
    "organization_name",
    "area",
  ]
}

const exclusiveFilterGroups = [
  ['year_2018', 'year_2019', 'year_2020'],
  ['size_1', 'size_2', 'size_3'],
]

class Events extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filteredEvents: this.props.events,
      filters: {
        searchTerm: "",
        year_2020: true,
      },
      fuse: new Fuse(this.props.events, fuseOptions),
      sortBy: 'name',
      toolboxActive: false,
    }
    this.props.getEvents();
    // setInterval(() => {
    //   this.props.getEvents();
    // }, 10 * 1000)
    this.updateSortBy = this.updateSortBy.bind(this)
    this.toggleToolbox = this.toggleToolbox.bind(this)
    this.onInputChange = this.onInputChange.bind(this)
    this.handleClick = this.handleClick.bind(this)

    this.toolboxRef = React.createRef();
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    let fuse = new Fuse(nextProps.events, fuseOptions)
    return {
      filteredEvents: Events.eventsForFilters(nextProps.events, prevState.filters, fuse, prevState.sortBy),
      fuse: fuse
    };
  }

  static eventsForFilters(events, filters, fuse, sortBy) {
    let order = 'desc'
    if (sortBy === 'name') {
      order = 'asc'
    }

    const sortFunction = (first, second) => {
      let firstValue, secondValue
      switch(sortBy) {
        case 'name':
          firstValue = first.name.toLowerCase()
          secondValue = second.name.toLowerCase()
          break;
        case 'date':
          firstValue = first.updated_at
          secondValue = second.updated_at
          break;
        default:
          firstValue = first.name.toLowerCase()
          secondValue = second.name.toLowerCase()
          break;
      }
      if (firstValue > secondValue) { return order === 'asc' ? 1 : -1 }
      if (firstValue === secondValue) { return 0 }
      if (firstValue < secondValue) { return order === 'asc' ? -1 : 1}
    }
    if (!events) {
      return [];
    }
    if (!filters) {
      return events.sort(sortFunction);
    }
    let listOfEvents = events;
    
    if (filters.size_1) { listOfEvents = listOfEvents.filter(event => event.capacity === hostType.HOST) }
    if (filters.size_2) { listOfEvents = listOfEvents.filter(event => event.capacity === hostType.DOUBLEHOST) }
    if (filters.size_3) { listOfEvents = listOfEvents.filter(event => event.capacity === hostType.SUPERHOST) }
    if (filters.organization) { listOfEvents = listOfEvents.filter(event => typeof event.organization_name === 'string' && event.organization_name !== '') }
    // if (filters.incomplete) { listOfEvents = listOfEvents.filter(event => event.postal_code === null) }
    if (filters.follow_up) { listOfEvents = listOfEvents.filter(event => event.follow_up === true) }
    // if (filters.premium) { listOfEvents = listOfEvents.filter(event => event.premium === true) }
    if (filters.public) { listOfEvents = listOfEvents.filter(event => event.public === true || event.public_access === true) }
    if (filters.swag) { listOfEvents = listOfEvents.filter(event => event.swag === true) }
    if (filters.will_share) { listOfEvents = listOfEvents.filter(event => event.share_preferences === 2 || event.share_preferences === 3) }
    
    if (filters.step_your_account) { listOfEvents = listOfEvents.filter(event =>
      checkRequiredFields(
        STEPS["profile"].requiredFields,
        event,
      )
    )}
    if (filters.step_save_the_date) { listOfEvents = listOfEvents.filter(event =>
      checkRequiredFields(
        STEPS["save-the-date"].requiredFields,
        event,
      )
    )}
    if (filters.step_get_a_gift) {
      listOfEvents = listOfEvents.filter(event => validRadio(event.swag, true))
    }
    if (filters.step_grant_application) {
      listOfEvents = listOfEvents.filter(event => validRadio(event.grant_agree, true))
    }
    if (filters.step_design_invitation) { listOfEvents = listOfEvents.filter(event =>
      checkRequiredFields(
        STEPS["event"].requiredFields,
        event,
      )
    )}
    if (filters.step_invite_guests) { listOfEvents = listOfEvents.filter(event =>
      checkRequiredFields(
        STEPS["how-to-invite"].requiredFields,
        event,
      )
    )}
    if (filters.step_guest_list) { listOfEvents = listOfEvents.filter(event =>
      checkRequiredFields(
        STEPS["guests"].requiredFields,
        event,
      )
    )}
    if (filters.step_send_a_reminder) { listOfEvents = listOfEvents.filter(event =>
      checkRequiredFields(
        STEPS["reminder"].requiredFields,
        event,
      )
    )}
    if (filters.step_send_a_thank_you) { listOfEvents = listOfEvents.filter(event =>
      checkRequiredFields(
        STEPS["thank-you"].requiredFields,
        event,
      )
    )}
    if (filters.step_share_your_experience) { listOfEvents = listOfEvents.filter(event =>
      checkRequiredFields(
        STEPS["share"].requiredFields,
        event,
      )
    )}

    if (filters.year_2018) { listOfEvents = listOfEvents.filter(e => e.year === 2018 ) }
    if (filters.year_2019) { listOfEvents = listOfEvents.filter(e => e.year === 2019 ) }
    if (filters.year_2020) { listOfEvents = listOfEvents.filter(e => e.year === 2020 ) }

    let monthsIndexes = []
    if (filters.month_jun) monthsIndexes.push(5)
    if (filters.month_jul) monthsIndexes.push(6)
    if (filters.month_aug) monthsIndexes.push(7)
    if (filters.month_sep) monthsIndexes.push(8)
    if (filters.month_oct) monthsIndexes.push(9)

    if (monthsIndexes.length > 0) { listOfEvents = listOfEvents.filter(e => monthsIndexes.indexOf(new Date(e.created_at).getMonth()) > -1 ) }
    
    let fuse2 = new Fuse(listOfEvents, fuseOptions)
    listOfEvents = filters.searchTerm.length > 0 ? fuse2.search(filters.searchTerm) : listOfEvents;

    listOfEvents = listOfEvents.sort(sortFunction).slice();

    return listOfEvents;
  }

  updateSelected = (event) => {
    if (event === this.props.selectedEvent) {
      this.props.updateSelectedEvent(null);
    } else {
      this.props.updateSelectedEvent(event);
    }
  }

  updateSortBy(e) {
    console.log('updateSortBy called!')
    if (e.target.id.indexOf('sort-by-') === 0) {
      this.setState({
        filteredEvents: Events.eventsForFilters(this.props.events, this.state.filters, this.state.fuse, e.target.id.slice(8)).slice(),
        sortBy: e.target.id.slice(8),
      })
    }
  }

  toggleToolbox(e) {
    this.setState({
      toolboxActive: !this.state.toolboxActive
    })
    e.preventDefault()
    return 0
  }

  handleFilterButtonToggle = (e) => {
    let filters = this.state.filters
    const filterId = e.target.id
    filters[filterId] = !filters[filterId]
    
    // if toggled on, toggle any other filter that's exclusive to this one
    if (filters[filterId]) {
      exclusiveFilterGroups.forEach((group) => {
        if (group.indexOf(filterId) >= 0) {
          group.forEach((siblingId) => {
            if (siblingId !== filterId) {
              filters[siblingId] = false
            }
          })
        }
      })
    }

    this.setState({
      filteredEvents: Events.eventsForFilters(this.props.events, filters, this.state.fuse, this.state.sortBy),
      filters: filters,
    });
  }

  onInputChange = (e) => {
    this.setState({
      filters: {
        ...this.state.filters,
        searchTerm: e.target.value.toLowerCase()
      }
    })
  }

  exportList = (e) => {
    const eventIds = this.state.filteredEvents.map((event) => event.id )
    const auth_token = JSON.parse(localStorage.getItem('auth_token'));
    window.open(`/api/admin/events/export?login_token=${auth_token}&events=${eventIds.join(',')}&order=id`, '_blank')
  }

  handleClick(e) {
    if (this.state.toolboxActive) {
      if (this.toolboxRef && this.toolboxRef.contains(e.target)) {
        return;
      } else {
        this.setState({
          toolboxActive: false
        })
      }  
    }
    
  }

  render() {
    let { filters } = this.state
    let hasFilters = Object.keys(filters).some((key) => filters[key])

    return (
      <styled.Main width="100%" style={{height: '100%'}} onClick={this.handleClick}>
        <Header currentUser={this.props.currentUser}/>
        <styled.AdminWrapper>
          <Notification type={this.props.alertType} message={this.props.alertMessage} />
          <styled.AdminPanes>
            <styled.AdminContent>
              <header style={{ marginBottom: '10px'}}>
                <div style={{ paddingBottom: '0px'}}>
                  <div style={{display: 'flex'}}>
                    <styled.ToolboxButton onClick={this.toggleToolbox} className={(this.state.toolboxActive ? "active " : "") + (hasFilters ? "has-filters " : "")}></styled.ToolboxButton>
                    <styled.FormField autoFocus onChange={this.onInputChange} placeholder="Search" />
                  </div>
                </div>
                <styled.AdminToolbox active={this.state.toolboxActive} innerRef={comp => this.toolboxRef = comp}>
                  <h3 style={{marginTop: "8px"}}>Admin filters</h3>
                  <styled.FilterButton selected={this.state.filters.follow_up} id='follow_up' onClick={this.handleFilterButtonToggle}><styled.FollowUp/>Needs Follow Up</styled.FilterButton>
                  <styled.FilterButton selected={this.state.filters.organization} id='organization' onClick={this.handleFilterButtonToggle}>Organizations</styled.FilterButton>
                  {/*<styled.FilterButton selected={this.state.filters.superhosts} id='superhosts' onClick={this.handleFilterButtonToggle}>Super Hosts</styled.FilterButton>*/}
                  <styled.FilterButton selected={this.state.filters.premium} id='premium' onClick={this.handleFilterButtonToggle}>Premium Host</styled.FilterButton>
                  <styled.FilterButton selected={this.state.filters.swag} id='swag' onClick={this.handleFilterButtonToggle}>Wants Gift</styled.FilterButton>
                  <styled.FilterButton selected={this.state.filters.public} id='public' onClick={this.handleFilterButtonToggle}>Public</styled.FilterButton>
                  {/*<styled.FilterButton selected={this.state.filters.incomplete} id='incomplete' onClick={this.handleFilterButtonToggle}><styled.Incomplete/>Incomplete</styled.FilterButton>*/}
                  <styled.FilterButton selected={this.state.filters.will_share} id='will_share' onClick={this.handleFilterButtonToggle}>Will Share</styled.FilterButton>
                  <h3 style={{marginTop: "8px"}}>Event size</h3>
                  <styled.FilterButton selected={this.state.filters.size_1} id='size_1' onClick={this.handleFilterButtonToggle}>12 or fewer</styled.FilterButton>
                  <styled.FilterButton selected={this.state.filters.size_2} id='size_2' onClick={this.handleFilterButtonToggle}>13 - 24</styled.FilterButton>
                  <styled.FilterButton selected={this.state.filters.size_3} id='size_3' onClick={this.handleFilterButtonToggle}>More than 24</styled.FilterButton>
                  <h3 style={{marginTop: "8px"}}>Step completion filters</h3>
                  <styled.FilterButton selected={this.state.filters.step_your_account} id='step_your_account' onClick={this.handleFilterButtonToggle}>Your Account</styled.FilterButton>
                  <styled.FilterButton selected={this.state.filters.step_save_the_date} id='step_save_the_date' onClick={this.handleFilterButtonToggle}>Save the Date</styled.FilterButton>
                  <styled.FilterButton selected={this.state.filters.step_get_a_gift} id='step_get_a_gift' onClick={this.handleFilterButtonToggle}>Applied for Gift</styled.FilterButton>
                  <styled.FilterButton selected={this.state.filters.step_grant_application} id='step_grant_application' onClick={this.handleFilterButtonToggle}>Applied for Grant</styled.FilterButton>
                  <styled.FilterButton selected={this.state.filters.step_design_invitation} id='step_design_invitation' onClick={this.handleFilterButtonToggle}>Design Invitation</styled.FilterButton>
                  <styled.FilterButton selected={this.state.filters.step_invite_guests} id='step_invite_guests' onClick={this.handleFilterButtonToggle}>Invite Guests</styled.FilterButton>
                  <styled.FilterButton selected={this.state.filters.step_guest_list} id='step_guest_list' onClick={this.handleFilterButtonToggle}>Guest List</styled.FilterButton>
                  <styled.FilterButton selected={this.state.filters.step_send_a_reminder} id='step_send_a_reminder' onClick={this.handleFilterButtonToggle}>Send a Reminder</styled.FilterButton>
                  <styled.FilterButton selected={this.state.filters.step_send_a_thank_you} id='step_send_a_thank_you' onClick={this.handleFilterButtonToggle}>Send a Thank You</styled.FilterButton>
                  <styled.FilterButton selected={this.state.filters.step_share_your_experience} id='step_share_your_experience' onClick={this.handleFilterButtonToggle}>Share Your Experience</styled.FilterButton>
                  <h3 style={{marginTop: "8px"}}>Period filters</h3>
                  <styled.FilterButton selected={this.state.filters.year_2018} id='year_2018' onClick={this.handleFilterButtonToggle}>2018</styled.FilterButton>
                  <styled.FilterButton selected={this.state.filters.year_2019} id='year_2019' onClick={this.handleFilterButtonToggle}>2019</styled.FilterButton>
                  <styled.FilterButton selected={this.state.filters.year_2020} id='year_2020' onClick={this.handleFilterButtonToggle} style={{marginRight: "16px"}}>2020</styled.FilterButton>
                  <styled.FilterButton selected={this.state.filters.month_jun} id='month_jun' onClick={this.handleFilterButtonToggle}>June</styled.FilterButton>
                  <styled.FilterButton selected={this.state.filters.month_jul} id='month_jul' onClick={this.handleFilterButtonToggle}>July</styled.FilterButton>
                  <styled.FilterButton selected={this.state.filters.month_aug} id='month_aug' onClick={this.handleFilterButtonToggle}>August</styled.FilterButton>
                  <styled.FilterButton selected={this.state.filters.month_sep} id='month_sep' onClick={this.handleFilterButtonToggle}>Sept</styled.FilterButton>
                  <styled.FilterButton selected={this.state.filters.month_oct} id='month_oct' onClick={this.handleFilterButtonToggle}>Oct</styled.FilterButton>
                  <h3 style={{marginTop: "8px"}}>List actions</h3>
                  <styled.MiniButton onClick={this.exportList}>Export this list</styled.MiniButton>
                </styled.AdminToolbox>
              </header>
              <div style={{marginBottom: '10px'}}>
                <h3 style={{ display: 'inline-block', marginRight: '8px' }}>Order hosts by:</h3>
                <styled.MiniButton id='sort-by-name' className={this.state.sortBy === 'name' ? "selected" : ""} onClick={this.updateSortBy} style={{marginRight: '8px'}}>Name</styled.MiniButton>
                <styled.MiniButton id='sort-by-date' className={this.state.sortBy === 'date' ? "selected" : ""} onClick={this.updateSortBy}>Last Modified</styled.MiniButton>
              </div>
              <EventsListContainer events={this.state.filteredEvents} onSelectedChange={this.updateSelected} />
            </styled.AdminContent>
            <EventsDetailContainer events={this.state.filteredEvents} onSelectedChange={this.updateSelected} />
          </styled.AdminPanes>
        </styled.AdminWrapper>
      </styled.Main>
    )
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    getEvents: () => {
      dispatch(eventActions.loadEvents())
    },
    updateSelectedEvent: (e) => {
      dispatch(eventActions.setSelectedEvent(e))
    },
  }
}

function mapStateToProps(state, ownProps) {
  const { message, type } = state.alerts;
  return {
    events: state.events.eventsArray,
    selectedEvent: state.selectedEvent.selectedEvent,
    selectedUser: state.selectedEvent.selectedUser,
    alertMessage: message,
    alertType: type,
    currentUser: state.users.currentUser
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Events)
